import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button 
        onClick={toggleMenu}
        className="text-gray-700 hover:text-red-600 cursor-pointer md:hidden"
        aria-label="Toggle menu"
      >
        <i className={`${isOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={closeMenu}
        ></div>
      )}

      {/* Mobile Menu Panel */}
      <div 
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold text-red-600" style={{ fontFamily: '"Pacifico", serif' }}>
            Menu
          </h2>
          <button 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 cursor-pointer"
            aria-label="Close menu"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <nav className="flex flex-col p-4 space-y-4">
          <Link 
            to="/" 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 font-medium py-2 cursor-pointer"
          >
            Home
          </Link>
          <Link 
            to="/services" 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 font-medium py-2 cursor-pointer"
          >
            Services
          </Link>
          <Link 
            to="/areas-covered" 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 font-medium py-2 cursor-pointer"
          >
            Areas Covered
          </Link>
          <Link 
            to="/about" 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 font-medium py-2 cursor-pointer"
          >
            About
          </Link>
          <Link 
            to="/contact" 
            onClick={closeMenu}
            className="text-gray-700 hover:text-red-600 font-medium py-2 cursor-pointer"
          >
            Contact
          </Link>

          <div className="pt-4 border-t">
            <a 
              href="tel:916-836-6145"
              className="block bg-red-600 text-white text-center px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors cursor-pointer"
            >
              Call (916) 836-6145
            </a>
          </div>
        </nav>
      </div>
    </>
  );
}
